import React from "react";
import { startCase, toLower } from "lodash";
import { isNil } from "lodash";

import styles from "./Bank.module.scss";

import { BankStatusLockMessage } from "./BankDisableText";
import ModalLink from "../../components/Shared/Modal/ModalLink/ModalLink";
import { EXIT_MODAL } from "../../redux/modules/modals/modals.module";
import { bankStatusLockMicroLink } from "../../settings/settings";
import { calculateAndFormatUnixDates } from "../../utils/date-utils";
import { isMobile } from "../../utils/dom-utils";

const BankOptions = ({ option, disabled}) => {
  const disabledLockActiveClass = disabled ? styles["lock-active"] : "";
  return (
    <div className="blocked-content blocked_data">
      <div className={`${styles["bank-name"]} ${disabledLockActiveClass} blocked_data`}>
        {option.name}&nbsp;- {option.bankAccountType} {option.accountNumber}
      </div>
      <div className={`${styles["name"]} ${disabledLockActiveClass} blocked_data`}>
        {option.registrationLines.map((name, key) => {
          const txt = `${startCase(toLower(name))}${
            key === option.registrationLines.length - 1 ? "" : ","
          }`;
          return <span key={key}> {txt} </span>;
        })}
      </div>
      {disabled && (
        <div className={`${styles["lock-note"]} ${option.bankStatus === "bankNotLinked" && styles['bank-notlinked']}`}>
          <BankStatusLockMessage lockMessage={option.bankStatus}/>{" "}
          {option.bankStatus === "processing"
            ? !isNil(option.availbeForRedemtionDate) &&
              calculateAndFormatUnixDates(option.availbeForRedemtionDate)
            : ""}
          {isMobile() && 
            <ModalLink
              link={
                <div className={styles["micro-link"]}>
                  {` ${bankStatusLockMicroLink[option.bankStatus] || ""}`}
                </div>
              }
              linkStyle="link"
              modalProps={{
                url:
                  "https://www.troweprice.com/usis/my-accounts/profile/linked-bank-accounts",
              }}
              modalName={EXIT_MODAL}
            />
          }
        </div>
      )}
    </div>
  );
};

export default BankOptions;
